import React, { useState, useEffect, useRef } from 'react'
import formatDate from 'helpers/dateTimeFormatter'
import numberFormatter from 'helpers/numberFormatter'
import { Checkbox, Number as NumberInput } from 'components/forms'
import { aggregateSumV2, numberColumn, toLocal } from 'components/DataTableTest'
import { ConfirmModal } from 'components/Modal'
import { Loading } from 'media/icons'
import { PDFSymbol } from 'media/icons'
import { NumberCell } from 'components/DataTableTest'

export const totalList = (t, locales, { commonData }) => [
	{
		Header: <span className='sort-icons'>{t('common.fields.date')}</span>,
		accessor: 'dateTime',
		Footer: `${t('common.strings.table_footer_total')} ${toLocal(commonData?.cashAssist?.listClosings?.total, { locales, toFixed: 0 })}`,
		width: 110,
		Cell: ({ value }) => formatDate(value, 'DD.MM.YYYY')
	}, {
		Header: t('common.fields.time'),
		accessor: 'dateTime',
		sortable: false,
		Cell: ({ value }) => formatDate(value, 'HH:mm:ss'),
		width: 80
	}, {
		Header: <span className='sort-icons'>{t('common.fields.number_short')}</span>,
		accessor: 'number',
		width: 60,
		style: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.fields.cash_register'),
		sortable: false,
		accessor: 'cashRegister.name',
		Cell: ({ value }) => <div title={value}>{value}</div>
	}, {
		Header: <span className='sort-icons'>{t('common.fields.total_price')}</span>,
		accessor: 'total',
		resizable: false,
		width: 100,
		...numberColumn({ locales }),
		Footer: `${toLocal(commonData?.cashAssist?.listClosings?.totalAmount, { locales })}`
	}
]


export const total_salesGroup = t => [
	{
		Header: t('closing_section.fields.sales_group'),
		accessor: 'salesGroup.name',
		aggregate: (_, { isFooter }) => isFooter ? t('common.strings.table_footer_total') : null,
		width: 205
		/* Cell: ({ row: { original } }, r) => original.salesGroup ? original.salesGroup.name : t('closing_section.strings.no_sales_group'),
		Footer: t('common.strings.table_footer_total'),
		width: 177, */
	}, {
		Header: t('closing_section.fields.quantity'),
		accessor: 'amount',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum', toFixed: 0 }),
		width: 85
		// Cell: ({ value }) => Number.isInteger(value) ? Number(value) : Number(value).toFixed(2)
		/* Cell: NumberCell({ toFixed: 2 }),
		Footer: FooterSum({ toFixed: 2 }) */
	}, {
		Header: t('closing_section.fields.discount'),
		accessor: 'discount',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum' }),
		width: 85
		/* Cell: NumberCell({ toFixed: 2 }),
		Footer: FooterSum({ toFixed: 2 }) */
	}, {
		Header: t('closing_section.fields.reduction'),
		accessor: 'reduction',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum' }),
		width: 85
		/* Cell: NumberCell({ toFixed: 2 }),
		Footer: FooterSum({ toFixed: 2 }) */
	}, {
		Header: t('closing_section.fields.vat_free'),
		accessor: 'mWStFree',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum' }),
		width: 85
		/* Cell: NumberCell({ toFixed: 2 }),
		Footer: FooterSum({ toFixed: 2 }) */
	}, {
		Header: t('closing_section.fields.vat_normal'),
		accessor: 'mWStNormal',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum' }),
		width: 85
		/* Cell: NumberCell({ toFixed: 2 }),
		Footer: FooterSum({ toFixed: 2 }) */
	}, {
		Header: t('closing_section.fields.vat_reduced'),
		accessor: 'mWStReduced',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum' }),
		width: 85
		/* Cell: NumberCell({ toFixed: 2 }),
		Footer: FooterSum({ toFixed: 2 }) */
	}, {
		Header: t('common.fields.total_price'),
		accessor: 'total',
		format: (options = {}) => numberColumn({ ...options, aggregateType: 'sum' }),
		width: 85
		/* Cell: NumberCell({ toFixed: 2 }),
		Footer: FooterSum({ toFixed: 2 }) */
	}
]

const EditableCell = ({ value = 0, updateData }) => {
	const [newValue, setNewValue] = useState(value)
	const isModalActive = useRef()

	const onBlur = () => {
		if (!isModalActive.current) {
			isModalActive.current = true
			ConfirmModal({
				label: 'Bestätigen',
				text: 'Die Daten wurden geändert. Änderungen speichern?',
				btnCancelText: 'Nein',
				onClose: () => {
					setNewValue(value)
					isModalActive.current = false
				}
			}).then(
				confirmed => {
					updateData(newValue)
					isModalActive.current = false
				},
				rejected => {
					setNewValue(value)
					isModalActive.current = false
				}
			).catch(e => { })
		}
	}

	// If the initial value is changed external, sync it up with our state
	useEffect(() => {
		setNewValue(value)
	}, [value])

	const handleChangeNumber = (val) => {
		if(!newValue) {
			const firstDigitStr = Number(String(val)[0])
			setNewValue(firstDigitStr)
		} else {
			setNewValue(val)
		}
	}

	return (
		value !== null
			?
			<NumberInput
				style={{ padding: '0', fontWeight: '300', textAlign: 'right', color: '#3e4c57' }}
				value={newValue && newValue}
				onChange={handleChangeNumber}
				precision={2}
				withControls={false}
				format='currency'
				noForm
				onBlur={onBlur}
			/>
			:
			''
	)
}


export const total_currency = (mainCurrency, updateData, locale) => t => [
	{
		Header: t('closing_section.fields.currency'),
		accessor: 'name',
		width: 80
	}, {
		Header: t('closing_section.fields.currency_present'),
		accessor: 'present',
		Cell: ({ original, value }) => <EditableCell value={value || 0} updateData={(e) => updateData(original?.name, e) } />,
		width: 140,
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('closing_section.fields.exchange_rate'),
		accessor: 'exchangeRate',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value : '',
		width: 80,
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: `${t('closing_section.fields.currency_present_converted')} ${mainCurrency}`,
		accessor: 'presentConverted',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('closing_section.fields.cash_in_transit'),
		accessor: 'cashInTransit',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value : '',
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('closing_section.fields.difference'),
		accessor: 'difference',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.fields.amount'),
		accessor: 'amount',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: `${t('closing_section.fields.amount_converted')} ${mainCurrency}`,
		accessor: 'amountConverted',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}
]

export const total_credit = t => [
	{
		Header: t('closing_section.fields.credit'),
		accessor: 'name'
	}, {
		Header: t('common.fields.number'),
		accessor: 'count',
		format: (defaultOptions = {}) => numberColumn({ ...defaultOptions, toFixed: 0 })
	}, {
		Header: t('common.fields.amount'),
		accessor: 'amount',
		format: defaultOptions => numberColumn(defaultOptions)
	}
]

export const total_output = t => [
	{
		Header: t('closing_section.fields.outputCashbook'),
		accessor: 'name'
	}, {
		Header: t('common.fields.amount'),
		accessor: 'amount',
		format: defaultOptions => numberColumn(defaultOptions)
	}
]

export const total_statistics = (t) => [
	{
		Header: t('closing_section.fields.statistics'),
		accessor: '0'
	}, {
		Header: '',
		accessor: '1',
		sortable: false,
		style: { justifyContent: 'flex-end' }
	}
]

export const total_specialOps = t => [
	{
		Header: t('closing_section.fields.special_ops'),
		accessor: 'name'
	}, {
		Header: t('common.fields.amount'),
		accessor: 'amount',
		format: defaultOptions => numberColumn(defaultOptions)
	}
]

export const total_rate = (t, locale) => [
	{
		Header: t('closing_section.fields.percent'),
		accessor: 'percent',
		Cell: ({ value }) => value ? `${value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		})}%` : '-',
		width: 85
	}, {
		Header: t('closing_section.fields.sales'),
		accessor: 'sales',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.vat'),
		accessor: 'MWSt',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.netto'),
		accessor: 'total',
		format: defaultOptions => numberColumn(defaultOptions)
	}
]

export const users = (t, locales) => [
	{
		Header: t('common.fields.code'),
		accessor: 'user.code',
		Footer: t('common.strings.table_footer_total')
	}, {
		Header: t('common.fields.name'),
		accessor: 'user.name',
		Footer: ' '
	}, {
		Header: t('common.fields.total_price'),
		accessor: 'total',
		Footer: ({ data }) => aggregateSumV2(data, 'total', { locales, toFixed: 2 }) || ' ',
		Cell: NumberCell({ locales }),
		style: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('closing_section.fields.bill_count'),
		accessor: 'clientCount',
		Cell: ({ value }) => value === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => aggregateSumV2(data, 'clientCount', { locales, toFixed: 0 }) || ' '
	}, {
		Header: t('closing_section.fields.bill_average'),
		accessor: 'averageBill',
		Cell: NumberCell({ locales }),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => aggregateSumV2(data, 'averageBill', { locales, toFixed: 2 }) || ' '
	}, {
		Header: t('closing_section.fields.cashier_efficiency'),
		accessor: 'userEfficiency',
		Cell: ({ value }) => value ? `${value}%` : '-',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		},
		Footer: ' '
	}, {
		Header: t('closing_section.fields.cancelation_count'),
		accessor: 'cancellationsCount', //Number
		show: true,
		Cell: ({ value }) => value === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => aggregateSumV2(data, 'cancellationsCount', { locales, toFixed: 0 }) || ' '
	}, {
		Header: t('closing_section.fields.cancelation_amount'),
		accessor: 'cancellationsAmount',
		show: true,
		Cell: ({ value }) => value === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => aggregateSumV2(data, 'cancellationsAmount', { locales, toFixed: 0 }) || ' '
	}, {
		Header: t('closing_section.fields.open_count'),
		accessor: 'buttonOpenCount',
		show: true,
		Cell: ({ value }) => Math.trunc(value) === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => aggregateSumV2(data, 'buttonOpenCount', { locales, toFixed: 0 }) || ' '
	}, {
		Header: t('closing_section.fields.back_button_count'),
		accessor: 'buttonBackCount',
		Cell: ({ value }) => Math.trunc(value) === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => (aggregateSumV2(data, 'buttonBackCount', { locales, toFixed: 0 }) || ' ')
	}, {
		Header: t('closing_section.fields.delete_button_count'),
		accessor: 'buttonDelCount',
		Cell: ({ value }) => Math.trunc(value) === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => (aggregateSumV2(data, 'buttonDelCount', { locales, toFixed: 0 }) || ' ')
	}, {
		Header: t('closing_section.fields.delete_button_amount'),
		accessor: 'buttonDelAmount',
		show: true,
		Cell: NumberCell({ locales }),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => (aggregateSumV2(data, 'buttonDelAmount', { locales, toFixed: 2 }) || ' ')
	}, {
		Header: t('closing_section.fields.in_cafe_count'),
		accessor: 'inCafeCount',
		show: true,
		Cell: ({ value }) => Math.trunc(value) === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => (aggregateSumV2(data, 'inCafeCount', { locales, toFixed: 0 }) || ' ')
	}, {
		Header: t('closing_section.fields.in_cafe_amount'),
		accessor: 'inCafeAmount',
		show: true,
		Cell: ({ value }) => Math.trunc(value) === 0 ? '' : Number(value).toFixed(0),
		style: {
			justifyContent: 'flex-end'
		},
		Footer: ({ data }) => (aggregateSumV2(data, 'inCafeAmount', { locales, toFixed: 0 }) || ' ')
	}, {
		Header: t('closing_section.fields.in_cafe_percent'),
		accessor: 'inCafePercent',
		show: true,
		Cell: ({ value }) => value ? `${value}%` : '-',
		Footer: ' '
	}
]

export const bill_bills = (t, locale, handlePdfClick, pdfsLoading, cashRegisterId) => [
	{
		id: 'date',
		Header: t('common.fields.date'),
		accessor: 'dateTime',
		width: 100,
		searchable: false,
		Cell: ({ value }) => formatDate(value, 'DD.MM.YYYY')
	}, {
		id: 'time',
		Header: t('common.fields.time'),
		accessor: 'dateTime',
		sortable: false,
		searchable: false,
		Cell: ({ value }) => formatDate(value, 'HH:mm:ss'),
		width: 80
	}, {
		Header: t('closing_section.strings.bill_pdf'),
		Cell: (row) => {
			const billNumber = row?.original?.number
			const isLoading = pdfsLoading[billNumber]
			if(isLoading) {
				return <Loading />
			}
			return (
				<PDFSymbol
					onClick={handlePdfClick({ billNumber, cashRegisterId })}
					style={{ display: 'block', width: '21px', height: '21px' }}
				/>
			)
		}
	}, {
		Header: t('closing_section.fields.bill_number'),
		accessor: 'number',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.fields.code'),
		accessor: 'user.code',
		searchable: false
	}, {
		Header: t('closing_section.fields.cashier_name'),
		searchable: false,
		accessor: 'user.name'
	}, {
		Header: t('common.fields.total'),
		searchable: false,
		accessor: 'total',
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}
]

export const bill_items = (t, locale) => [
	{
		Header: t('common.fields.quantity'),
		accessor: 'amount',
		Cell: (rowState) => !Number(rowState?.value) ? null : NumberCell({ toFixed: 0, locales: locale })(rowState),
		style: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.fields.name'),
		accessor: 'product.name',
		Cell: ({ value, original }) => {
			if (value) {
				return value
			}
			switch (original.flag) {
				case 'TotalAmount':
					return t('closing_section.strings.billitem_total_amount')
				case 'TotalInEuro':
					return `${t('closing_section.strings.billitem_given')} (€ ${numberFormatter(original.mul1, { locale, toFixed: 2 })}) `
				case 'Retour':
					return t('closing_section.strings.billitem_given_back')
				case 'TotalInCardValue':
					return t('closing_section.strings.billitem_total_in_card_value')
				case 'TotalInCreditClient':
					return t('closing_section.strings.billitem_total_in_credit_client')
				case 'TotalInCHF':
					return t('closing_section.strings.billitem_given')
				default:
					return original.flag || ''
			}
		}
	}, {
		Header: t('common.fields.amount'),
		accessor: 'price',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('closing_section.fields.discount_percent'),
		accessor: 'discountPercent',
		Cell: ({ value }) => value ? `${value}%` : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('closing_section.fields.vat'),
		accessor: 'codeMWSt',
		Cell: ({ value }) => {
			switch (value) {
				case 'free':
					return t('closing_section.fields.vat_free')
				case 'normal':
					return t('closing_section.fields.vat_normal')
				case 'reduced':
					return t('closing_section.fields.vat_reduced')
				case 'special':
					return t('closing_section.fields.vat_special')
				default:
					return value
			}
		}
	}, {
		Header: t('closing_section.fields.in_cafe'),
		accessor: 'inCafe',
		width: 70,
		Cell: ({ value }) => <Checkbox noForm readOnly checked={value} />
	}, {
		Header: t('common.fields.total'),
		accessor: 'total',
		format: defaultOptions => numberColumn(defaultOptions),
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		}
	}
]

export const bill_discounts = t => [
	{
		Header: t('common.fields.name'),
		accessor: 'name'
	}, {
		Header: t('common.fields.amount'),
		accessor: 'amount',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.charge_extra'),
		accessor: 'extraCharge',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.sales_group'),
		accessor: 'salesGroup'
	}, {
		Header: t('closing_section.fields.sales_to'),
		accessor: 'sales_smth',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.transfer"'),
		accessor: 'transfer',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.sales'),
		accessor: 'sales',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.price_reduction'),
		accessor: 'discount',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('closing_section.fields.price_diff'),
		accessor: 'priceDifference',
		format: defaultOptions => numberColumn(defaultOptions)
	}
]

export const priceDifference = t => [
	{
		Header: t('common.fields.quantity'),
		accessor: 'quantity',
		...numberColumn({ toFixed: 0 })
	}, {
		Header: t('common.fields.code'),
		accessor: 'product.code'
	}, {
		Header: t('common.fields.name'),
		accessor: 'product.name'
	}, {
		Header: t('closing_section.fields.reduction'),
		accessor: 'reduction',
		format: defaultOptions => numberColumn(defaultOptions)
	}, {
		Header: t('common.fields.type'),
		accessor: 'type'
	}
]

export const creditCustomer_orders = (t, locale) => [
	{
		Header: t('common.fields.code'),
		accessor: 'creditClient.clientNumber'
	}, {
		Header: t('common.fields.name'),
		accessor: 'creditClient.name'
	}, {
		Header: t('closing_section.fields.cash_register_name'),
		accessor: 'cashRegister.name'
	}, {
		Header: t('closing_section.fields.invoice_number'),
		accessor: 'invoiceId',
		format: (defaultOptions = {}) => numberColumn({ ...defaultOptions, toFixed: 0 })
	}, {
		Header: t('common.fields.total'),
		accessor: 'total',
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : ''
	}
]

export const creditCustomer_orderItems = (t, locale) => [
	{
		Header: t('common.fields.code'),
		accessor: 'product.code'
	}, {
		Header: t('common.fields.quantity'),
		accessor: 'amount',
		format: (defaultOptions = {}) => numberColumn({ ...defaultOptions, toFixed: 0 }),
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.fields.name'),
		accessor: 'product.name'
	}, {
		Header: t('common.fields.amount'),
		accessor: 'price',
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}, {
		Header: t('common.fields.total'),
		accessor: 'total',
		Cell: ({ value }) => value ? value.toLocaleString(locale, {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		}) : '',
		style: {
			justifyContent: 'flex-end'
		},
		headerStyle: {
			justifyContent: 'flex-end'
		}
	}
]

export const columnsShopStatistic = ({ t, locales }, ...rest) => {
	const [
		columnsTaxes = [],
		columnsPaymentMethods = [],
		columnsCoupons = [],
		columnsSpecialSales = [],
		columnsCurrency = []
	] = rest
	return ([{
		caption: t('common.strings.branch'),
		dataField: 'name',
		width: 150
	}, {
		caption: t('common.fields.total_price'), // Umsatz
		dataField: 'total',
		alignment: 'right',
		width: 90,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	},
	...columnsTaxes,
	...columnsCurrency,
	...columnsPaymentMethods,
	...columnsCoupons,
	...columnsSpecialSales,
	{
		caption: t('statistic_section.strings.number_of_customers'), //Anzahl Kunden
		dataField: 'clientCount',
		alignment: 'right',
		width: 120,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('statistic_section.strings.number_of_items'), //Anzahl Artikel
		dataField: 'productCount',
		alignment: 'right',
		width: 120,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}, {
		caption: t('closing_section.strings.statistic_total_per_client'), //Umsatz/Kunde
		dataField: '',
		calculateCellValue: (data) => {
			return (data?.total && data?.clientCount) ? (data.total / data.clientCount) : ''
		},
		summary: {
			summaryType: 'sum'
		},
		alignment: 'right',
		width: 120,
		localFormat: { type: 'float' }
	}, {
		caption: t('closing_section.strings.statistic_products_per_client'), //Artikel/Kunde
		dataField: '',
		calculateCellValue: (data) => {
			return (data?.productCount && data?.clientCount) ? (data.productCount / data.clientCount) : ''
		},
		summary: {
			summaryType: 'sum'
		},
		alignment: 'right',
		width: 120,
		localFormat: { type: 'float' }
	}, {
		caption: t('closing_section.strings.statistic_total_per_product'), // Umsatz/Artikel
		dataField: 'incomePerCustomer',
		calculateCellValue: (data) => {
			return (data?.total && data?.productCount) ? (data.total / data.productCount) : ''
		},
		summary: {
			summaryType: 'sum'
		},
		alignment: 'right',
		width: 120,
		localFormat: { type: 'float' }
	}, {
		caption: t('closing_section.strings.statistic_cancelations'), //Stornos
		dataField: 'cancellationsCount',
		alignment: 'right',
		width: 120,
		summary: {
			summaryType: 'sum'
		},
		localFormat: { type: 'float' }
	}
	])
}
